import React from "react";
import { Link } from "react-router-dom";
import "./Navigationdowen.css";

import logo from "../img/logooo.png";

const Navigationdowen = () => {
  return (
    <footer className="footer">

      <div className="footer-content">

        <div className="footer-logo">
          <img src={logo} alt="SITE B2B" />
          <p>בניית אתרים לעסקים</p>
          <span>
            מקימים לעסק שלך נוכחות דיגיטלית שמביאה לקוחות
          </span>
        </div>

        <div className="footer-navigation">
          <h3>ניווט מהיר</h3>

          <div className="footer-links">
            <Link to="/">ראשי</Link>
            <Link to="/mysite">בניית אתרים</Link>
            <Link to="/about">אודות</Link>
            <Link to="/contact">צור קשר</Link>
      <a href="/תקנון-שימוש-באתר-הקמת אתרי אינטרנט לבעלי עסקים.pdf" target="_blank" rel="noopener noreferrer" > מדיניות פרטיות </a>
          </div>
        </div>

        <div className="footer-contact">
          <h3>צרו קשר</h3>

       

<a
  href="https://mail.google.com/mail/?view=cm&fs=1&to=siteb2b@gmail.co.il"
  target="_blank"
  rel="noopener noreferrer"
>
siteb2b2@gmail.com
</a>


          <p>
            שוהם 5, רמת גן
          </p>
        </div>

      </div>

      <div className="footer-bottom">

        <p>
          © 2026 SITE B2B — כל הזכויות שמורות
        </p>

        <span>•</span>

        <p>
          אתר נבנה ועוצב על ידי{" "}
          <Link to="/">
            SITE B2B
          </Link>
        </p>

      </div>

    </footer>
  );
};

export default Navigationdowen;
